export default function noop() {}



//////////////////
// WEBPACK FOOTER
// ./~/d3-geo/src/noop.js
// module id = 108
// module chunks = 1